import {SectionView} from '../../ui_canvas_engine/SectionView'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {SpriteExpansionArrowView} from '../../ui_canvas_engine/SpriteExpansionArrowView'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {PIXI} from '@colonist/pixi'

export abstract class UIGamePlayerInformationArrayView extends SectionView implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    protected readonly playerInformation: UIGamePlayerInformationView
    protected informationArrayArrow: SpriteExpansionArrowView
    protected mapPointerListener: (event: PIXI.FederatedPointerEvent) => void

    constructor(uiGameManager: UIGameManager, playerInformation: UIGamePlayerInformationView, x: number, y: number, w: number, h: number) {
        const removePadding = true
        super(x, y, w, h, playerInformation, removePadding)

        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.playerInformation = playerInformation

        this.mapPointerListener = (event: PIXI.FederatedPointerEvent) => {
            this.uiGameManager.eventController.sendEvent(undefined, GameStateEnums.UIGameEventEnums.PointerOutPlayerInformationView)
        }

        this.createInformationArrow()
    }

    private createInformationArrow() {
        const shouldShowWhiteArrow = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        this.informationArrayArrow = new SpriteExpansionArrowView(0, 0, this, 0, shouldShowWhiteArrow)
        this.informationArrayArrow.interactive = true
        this.setInformationArrayArrowInteractionEvents()
    }

    protected abstract setInformationArrayArrowInteractionEvents()

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.HoveredOverPlayerInformationArrow: this.informationArrayArrow.arrowPointRight(); break
            case UIGameEventEnums.PointerOutPlayerInformationView: this.informationArrayArrow.arrowPointLeft(); break
            default: break
        }
    }

    destroy() {
        super.destroy({children: true})

        this.uiGameManager.eventController.unregisterUIGameMechanic(this)

        if(!UIUtilsEjsVariables.isUserOnMobile) return
        const mapView = this.uiGameManager.mapController.mapView
        mapView.off('pointerdown', this.mapPointerListener)
    }
}
